import React from "react";
import PageLayout from "../components/common/page-layout";
import AdhocPreviewTool from "../components/ingestion-adhoc-preview/adhoc-preview-tool";
import { RequireAuth } from "../hooks/use-auth";

/**
 * The ad-hoc ingestion preview tool: upload a document for a company (optionally
 * simulating the ingesting email), run DE's production extractor against it, and
 * inspect the side-effect-free apply plan, retrieved exemplars, and cost the V3
 * apply WOULD produce — without touching real intake.
 */
const AdhocIngestionPreviewPage = () => {
  return (
    <RequireAuth>
      <PageLayout
        subtitle="New document-extraction pipeline"
        title="Ad-hoc ingestion preview"
      >
        <AdhocPreviewTool />
      </PageLayout>
    </RequireAuth>
  );
};

export default AdhocIngestionPreviewPage;
